/**
 * @description 路由级拦截：登录校验 + 可选的 projectId 校验
 */

import {useEffect} from 'react';
import {Navigate, useNavigate, useLocation, useSearchParams} from 'react-router-dom';
import {useAuthStore} from '@/store/useAuthStore';
import {useModalStore} from '@/store/useModalStore';

interface AuthRouteProps {
    children: React.ReactNode;
    /** 是否要求 projectId 存在，不存在则重定向到首页 */
    requireProjectId?: boolean;
}

const AuthRoute: React.FC<AuthRouteProps> = ({children, requireProjectId = false}) => {
    const isLogin = useAuthStore((s) => s.isLogin);
    const initialized = useAuthStore((s) => s.initialized);
    const toggleLoginModal = useModalStore((s) => s.toggleLoginModal);
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const projectId = searchParams.get('projectId');

    useEffect(() => {
        // 仅在初始化完成后判断登录状态，避免刷新时的竞态
        if (initialized && !isLogin) {
            toggleLoginModal(true);
            void navigate('/', {replace: true, state: {from: location.pathname}});
        }
    }, [isLogin, initialized, toggleLoginModal, navigate, location.pathname]);

    // 初始化中不渲染，避免闪烁
    if (!initialized) return null;

    if (!isLogin) return null;

    // projectId 拦截
    if (requireProjectId && !projectId) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AuthRoute;
